import controller from './detailed-payment.controller';
import template from './detailed-payment.view.html';

let DetailedPaymentComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DetailedPaymentComponent;



/** WEBPACK FOOTER **
 ** ./www/components/pay-zone/detailed-payment/detailed-payment.component.js
 **/